/* lys-rpdp-zoom.js — ouvrir en GRAND une image du lookbook ou une vidéo. 14/08/2026
 *
 * ⛔ CE QUI MANQUAIT, constaté dans le code et non supposé :
 *   · .rpdp-lb__grid ne contenait que des <img> SANS aucun écouteur. Cliquer une image du
 *     lookbook ne pouvait rien déclencher — et elles n'étaient servies qu'en width=600.
 *   · .rpdp-vid__card monte un <video> SANS attribut `controls`, en playsinline, et le bouton
 *     lecture joue DANS la vignette. Aucun requestFullscreen nulle part : la cliente n'avait
 *     aucun moyen d'agrandir. Les retours « ça ne s'ouvre pas » disaient vrai.
 *
 * ⚠ Le bouton lecture a DÉJÀ un écouteur, posé par lys-rpdp.js sur le bouton lui-même. On
 *   intercepte donc en phase de CAPTURE sur document : un stopPropagation() à ce moment-là
 *   empêche l'événement d'atteindre la cible, donc l'ancien écouteur ne joue pas. Sans cela
 *   deux lectures partiraient en même temps, avec le son en double.
 *
 * ⚠ <dialog>.showModal() donne le piège de focus, la touche Échap et l'arrière-plan sans une
 *   ligne de JS — et il est disponible sur Safari iOS depuis 15.4, qui fait 91 % des sessions.
 *   Repli prévu quand il manque : simple couche avec l'attribut hidden (jamais aria-hidden
 *   seul — 47 boutons fantômes relevés par Lighthouse le 10/08).
 */
(function () {
  'use strict';
  var grille = document.querySelector('.rpdp-lb__grid');
  var piste = document.getElementById('rpdpVidTrack');
  if (!grille && !piste) return;

  var CSS = '.rpdpz{border:0;padding:0;max-width:100vw;max-height:100vh;width:100vw;height:100vh;' +
    'background:rgba(20,17,15,.94);overflow:hidden}' +
    '.rpdpz::backdrop{background:rgba(20,17,15,.94)}' +
    '.rpdpz[hidden]{display:none}' +
    '.rpdpz__st{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:8px}' +
    '.rpdpz__st>img,.rpdpz__st>video{max-width:100%;max-height:100%;width:auto;height:auto;' +
    'display:block;border-radius:10px;background:#141110;object-fit:contain}' +
    '.rpdpz__b{position:absolute;z-index:2;width:46px;height:46px;border:0;border-radius:50%;' +
    'background:rgba(255,255,255,.16);color:#fff;font:400 22px/1 system-ui,sans-serif;cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;display:flex;align-items:center;justify-content:center}' +
    '.rpdpz__b:hover{background:rgba(255,255,255,.3)}' +
    '.rpdpz__b:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '.rpdpz__x{top:max(12px,env(safe-area-inset-top));right:12px;font-size:26px}' +
    '.rpdpz__p{left:12px;top:50%;transform:translateY(-50%)}' +
    '.rpdpz__n{right:12px;top:50%;transform:translateY(-50%)}' +
    '.rpdpz__c{position:absolute;z-index:2;left:50%;transform:translateX(-50%);' +
    'bottom:max(14px,env(safe-area-inset-bottom));color:#fff;font:500 12px/1 system-ui,sans-serif;' +
    'letter-spacing:.14em;background:rgba(0,0,0,.42);padding:8px 14px;border-radius:20px}' +
    '.rpdp-lb__grid img{cursor:zoom-in}.rpdp-vid__card{cursor:zoom-in}' +
    '@media(max-width:600px){.rpdpz__p,.rpdpz__n{display:none}}';

  var st = document.createElement('style');
  st.textContent = CSS;
  document.head.appendChild(st);

  var dlg = document.createElement(typeof HTMLDialogElement === 'function' ? 'dialog' : 'div');
  var natif = typeof dlg.showModal === 'function';
  dlg.className = 'rpdpz';
  dlg.setAttribute('aria-label', 'Agrandissement');
  if (!natif) { dlg.hidden = true; dlg.style.position = 'fixed'; dlg.style.inset = '0'; dlg.style.zIndex = '9999'; }
  dlg.innerHTML =
    '<div class="rpdpz__st"></div>' +
    '<button type="button" class="rpdpz__b rpdpz__x" aria-label="Fermer">&#10005;</button>' +
    '<button type="button" class="rpdpz__b rpdpz__p" aria-label="Précédent">&#8249;</button>' +
    '<button type="button" class="rpdpz__b rpdpz__n" aria-label="Suivant">&#8250;</button>' +
    '<div class="rpdpz__c"></div>';
  document.body.appendChild(dlg);

  var stage = dlg.querySelector('.rpdpz__st');
  var cpt = dlg.querySelector('.rpdpz__c');
  var lot = [];      /* {type:'img'|'video', src, alt} */
  var idx = 0;

  /* ⚠ le lookbook est servi en width=600 : suffisant pour une vignette, flou en plein écran.
     On reconstruit l'URL en 1600 — même image, le CDN Shopify fait le redimensionnement. */
  function grand(u) {
    if (!u) return u;
    return /(\?|&)width=\d+/.test(u) ? u.replace(/(\?|&)width=\d+/, '$1width=1600')
                                     : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
  }

  function vider() {
    var v = stage.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    stage.textContent = '';
  }

  function montrer() {
    var it = lot[idx];
    if (!it) return;
    vider();
    var el;
    if (it.type === 'video') {
      el = document.createElement('video');
      el.src = it.src;
      el.controls = true;              /* ⛔ c'est CE qui manquait : plein écran, son, barre */
      el.playsInline = true;
      el.preload = 'metadata';
      if (it.poster) el.poster = it.poster;
      el.setAttribute('controlsList', 'nodownload');
      stage.appendChild(el);
      var pr = el.play();
      if (pr && pr.catch) pr.catch(function () { /* iOS peut exiger un geste : les contrôles sont là */ });
    } else {
      el = document.createElement('img');
      el.src = it.src;
      el.alt = it.alt || '';
      el.decoding = 'async';
      stage.appendChild(el);
    }
    cpt.textContent = lot.length > 1 ? (idx + 1) + ' / ' + lot.length : '';
    var seul = lot.length < 2;
    dlg.querySelector('.rpdpz__p').style.display = seul ? 'none' : '';
    dlg.querySelector('.rpdpz__n').style.display = seul ? 'none' : '';
  }

  function ouvrir(liste, i) {
    lot = liste; idx = i || 0;
    /* on arrête toute vidéo qui jouait déjà dans sa vignette : sinon deux sons se superposent */
    Array.prototype.forEach.call(document.querySelectorAll('.rpdp-vid__card video'), function (v) {
      try { v.pause(); } catch (e) {}
    });
    montrer();
    if (natif) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    else { dlg.hidden = false; }
    document.documentElement.style.overflow = 'hidden';
  }

  function fermer() {
    vider();
    if (natif) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
    else { dlg.hidden = true; }
    document.documentElement.style.overflow = '';
  }

  function bouger(d) {
    if (lot.length < 2) return;
    idx = (idx + d + lot.length) % lot.length;
    montrer();
  }

  dlg.addEventListener('click', function (e) {
    if (e.target.closest('.rpdpz__x')) return fermer();
    if (e.target.closest('.rpdpz__p')) return bouger(-1);
    if (e.target.closest('.rpdpz__n')) return bouger(1);
    /* clic dans le vide (hors média) = fermeture, comme partout ailleurs */
    if (e.target === dlg || e.target === stage) fermer();
  });
  dlg.addEventListener('cancel', function () { vider(); document.documentElement.style.overflow = ''; });
  document.addEventListener('keydown', function (e) {
    var ouvert = natif ? dlg.open : !dlg.hidden;
    if (!ouvert) return;
    if (e.key === 'ArrowLeft') bouger(-1);
    else if (e.key === 'ArrowRight') bouger(1);
    else if (e.key === 'Escape' && !natif) fermer();
  });

  var tx = 0, ty = 0;
  dlg.addEventListener('touchstart', function (e) {
    tx = e.changedTouches[0].clientX; ty = e.changedTouches[0].clientY;
  }, { passive: true });
  dlg.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) bouger(dx < 0 ? 1 : -1);
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) fermer();
  }, { passive: true });

  /* ── ouverture depuis le lookbook ──────────────────────────────────────────────────────
     ⛔⛔ LA DÉLÉGATION ÉTAIT LA PANNE — cinquième signalement du patron sur ce même clic.
     Ce bloc commençait par `if (visionneuseDispo()) return;` : dès que le thème exposait
     window.__rpdpLb, zoom.js s'effaçait « puisque quelqu'un s'en occupe ». Or sur les fiches
     AVEC vidéo, __rpdpLb existe mais n'ouvre rien — son code est enfermé dans une condition
     étrangère (`if (C)` où C = #rpdpVideo). Le seul mécanisme qui marchait se désactivait donc
     devant un mécanisme cassé, et le clic mourait en silence. J'ai « corrigé » quatre fois le
     mécanisme, jamais la délégation.
     ✅ ON NE DÉLÈGUE PLUS. On prend le clic en phase de CAPTURE et on coupe la propagation :
     la visionneuse du thème ne peut plus être atteinte, donc aucun doublon possible.
     Règle : un mécanisme qui marche ne s'efface jamais devant un mécanisme supposé. */
  if (grille) {
    grille.addEventListener('click', function (e) {
      var im = e.target.closest && e.target.closest('img');
      if (!im || !grille.contains(im)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var tous = Array.prototype.slice.call(grille.querySelectorAll('img'));
      ouvrir(tous.map(function (x) {
        return { type: 'img', src: grand(x.getAttribute('src')), alt: x.alt };
      }), tous.indexOf(im));
    }, true);
    /* les vignettes portent role=button et tabindex=0 : au clavier elles doivent répondre
       aussi, sinon elles sont focusables mais inertes. */
    grille.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var im = e.target && e.target.tagName === 'IMG' ? e.target : null;
      if (!im) return;
      e.preventDefault();
      e.stopPropagation();
      im.click();
    }, true);
  }

  /* ── ouverture depuis les vidéos ───────────────────────────────────────────────────────
     ⚠ CAPTURE, et stopPropagation : lys-rpdp.js a posé son écouteur sur le bouton lecture
     lui-même. En capture on passe avant lui et on l'empêche d'être atteint — sinon la vidéo
     partirait dans la vignette EN PLUS de la grande, avec le son en double. */
  if (piste) {
    piste.addEventListener('click', function (e) {
      var carte = e.target.closest('.rpdp-vid__card');
      if (!carte) return;
      e.preventDefault();
      e.stopPropagation();
      var cartes = Array.prototype.slice.call(piste.querySelectorAll('.rpdp-vid__card'));
      ouvrir(cartes.map(function (c) {
        var v = c.querySelector('video');
        var s = (v && (v.getAttribute('src') || v.dataset.vsrc)) || '';
        return { type: 'video', src: s.replace(/#t=[\d.]+$/, ''), poster: v ? v.getAttribute('poster') : '' };
      }), cartes.indexOf(carte));
    }, true);
  }
})();
